import { SCHEMES, DEFAULT_FRAME_DURATION } from "./constants";

export const newFrame = (name, players = [], drawings = [], duration_ms = DEFAULT_FRAME_DURATION) => ({
  id: crypto.randomUUID(),
  name: name || "Frame",
  duration_ms,
  players,
  drawings,
});

export const cloneFrame = (f) => ({
  ...f,
  id: crypto.randomUUID(),
  players: f.players.map((p) => ({ ...p })),
  drawings: f.drawings.map((d) => ({ ...d, points: d.points ? d.points.map((p) => ({ ...p })) : undefined })),
});

export const buildInitialFrames = (scheme = "4-4-2") => [
  newFrame("Start", SCHEMES[scheme].map((p, i) => ({ ...p, id: i, color: "#0ea5e9" })), []),
];

// Linear interpolation between two frames at progress t in [0,1].
export function interpolateFrame(fa, fb, t) {
  const players = fa.players.map((pa) => {
    const pb = fb.players.find((p) => p.id === pa.id);
    if (!pb) return pa;
    return {
      ...pa,
      x: pa.x + (pb.x - pa.x) * t,
      y: pa.y + (pb.y - pa.y) * t,
    };
  });
  const drawings = fa.drawings.map((da, idx) => {
    const db = fb.drawings[idx];
    if (!db || db.type !== da.type) return da;
    if (da.type === "line" || da.type === "arrow") {
      const [a1, a2] = da.points || [];
      const [b1, b2] = db.points || [];
      if (!a1 || !a2 || !b1 || !b2) return da;
      return {
        ...da,
        points: [
          { x: a1.x + (b1.x - a1.x) * t, y: a1.y + (b1.y - a1.y) * t },
          { x: a2.x + (b2.x - a2.x) * t, y: a2.y + (b2.y - a2.y) * t },
        ],
      };
    }
    if (da.type === "text" || da.type === "goal") {
      return {
        ...da,
        x: da.x + (db.x - da.x) * t,
        y: da.y + (db.y - da.y) * t,
      };
    }
    return da; // free: snap at frame boundary
  });
  return { ...fa, players, drawings };
}
